import { render, staticRenderFns } from "./dfoList.vue?vue&type=template&id=19ccab8c"
import script from "./dfoList.vue?vue&type=script&lang=js"
export * from "./dfoList.vue?vue&type=script&lang=js"
import style0 from "./dfoList.vue?vue&type=style&index=0&id=19ccab8c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports